module.exports = __webpack_public_path__ + "img/order-step2-b.28f78cd5.png";